import { Button, Box, Stack, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";
import noResults from "../../../../../../../../../../public/images/noSearchResults.jpg";
import { Trans, useTranslation } from "react-i18next";
type NoResultsProps = {
  query: string;
  onSearchAgain: () => void;
};
export const NoResults = ({
  query,
  onSearchAgain
}: NoResultsProps) => {
  const {
    t
  } = useTranslation();
  return <Stack gap={2.5} alignItems="center" p={2.5} data-sentry-element="Stack" data-sentry-component="NoResults" data-sentry-source-file="NoResults.tsx">
      <img src={noResults} alt={t("content.itemListNoSearchResultsAlt")} loading="lazy" height={120} />
      <Box width={339} sx={{
      whiteSpace: "break-spaces",
      textAlign: "center"
    }} data-sentry-element="Box" data-sentry-source-file="NoResults.tsx">
        <Typography variant="h5" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="NoResults.tsx">
          <Trans i18nKey="content.itemEditStatusSearchNoResultsTitleRich" values={{
          search: query
        }} components={{
          strong: <strong />
        }} data-sentry-element="Trans" data-sentry-source-file="NoResults.tsx" />
        </Typography>
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="NoResults.tsx">
          {t("content.itemListSearchNoResultsBody")}
        </Typography>
      </Box>
      <Button variant="contained" startIcon={<Search />} onClick={onSearchAgain} data-sentry-element="Button" data-sentry-source-file="NoResults.tsx">
        {t("common.searchAgain")}
      </Button>
    </Stack>;
};